module.exports = __webpack_public_path__ + "img/logo.d35665cc.svg";